import { Utils } from '@sparrow-marketing/contracts';

export const formatIndexDBData = (props: Utils.DynamicObject) => {
  const allData = { ...props };

  const sourceIds = [
    ...new Set(
      Object.values(allData ?? {})
        ?.map(t => Object.keys(t ?? {}))
        ?.flat() ?? []
    ),
  ];

  let formattedToState: Utils.DynamicObject = {};

  sourceIds.forEach(sourceId => {
    Object.keys(allData).forEach(key => {
      formattedToState = {
        ...formattedToState,
        [sourceId]: {
          ...(formattedToState?.[sourceId] ?? {}),
          ...(allData?.[key]?.[sourceId] ?? {}),
        },
      };
    });
  });

  return formattedToState;
};
